"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NicamIcons = void 0;
var player_config_1 = require("../typings/player-config");
var NicamIcons = (function () {
    function NicamIcons(clientNicamIconsConfig, apiNicamIconsConfig) {
        var _this = this;
        this.name = 'Default';
        this.showFullScreen = true;
        this.showNormalScreen = true;
        this.position = player_config_1.NicamIconsPositions.TOP_LEFT;
        this.iconSize = 32;
        this.margin = 10;
        if (apiNicamIconsConfig) {
            this.name = apiNicamIconsConfig.name;
            this.position = apiNicamIconsConfig.position;
            if (apiNicamIconsConfig.iconSize)
                this.iconSize = apiNicamIconsConfig.iconSize;
            if (apiNicamIconsConfig.margin)
                this.margin = apiNicamIconsConfig.margin;
            if (typeof apiNicamIconsConfig.showFullScreen !== 'undefined')
                this.showFullScreen = apiNicamIconsConfig.showFullScreen;
            if (typeof apiNicamIconsConfig.showNormalScreen !== 'undefined')
                this.showNormalScreen = apiNicamIconsConfig.showNormalScreen;
        }
        if (clientNicamIconsConfig) {
            Object.keys(clientNicamIconsConfig).forEach(function (key) {
                if (typeof _this[key] === 'undefined') {
                    console.warn("Invalid NICAM option \"".concat(key, "\""));
                    return;
                }
                _this[key] = clientNicamIconsConfig[key];
            });
        }
    }
    return NicamIcons;
}());
exports.NicamIcons = NicamIcons;
